
import { Booking } from "@/api/dtos/Booking.schema";
import { rentalStatusToGerman } from "@/misc/i18n";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  formatBookingDateTime,
  hasBookingTimeZone,
} from "@/utils/bookingDateFormatter";
import EditButton from "../buttons/EditButton.vue";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    EditButton,
    CancelButton,
    DangerButton,
  },
})
export default class TinyBookingsTable extends Vue {
  @Prop({
    default: 1,
  })
  deviceNumber!: number;

  @Prop()
  stationId!: string;

  @Prop({
    default: () => [] as Booking[],
  })
  bookings!: Booking[];

  rentalStatusToGerman = rentalStatusToGerman;
  moment = moment;
  formatBookingDateTime = formatBookingDateTime;
  hasBookingTimeZone = hasBookingTimeZone;

  readonly headers: {
    text: string;
    value: string;
    align?: "start" | "center" | "end";
  }[] = [
    {
      text: "Buchungs-ID",
      value: "bookingId",
    },
    {
      text: "von",
      value: "start",
    },
    {
      text: "bis",
      value: "end",
    },
    {
      text: "Status",
      value: "status",
    },
  ];

  get filteredBookings(): Booking[] {
    return this.bookings.filter(
      (booking) => booking.device === this.deviceNumber
    );
  }
}
